export enum NetworkEffectiveType {
    Slow2G = 'slow-2g',
    TwoG = '2g',
    ThreeG = '3g',
    FourG = '4g'
  }
  